import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import Axios from "../axios";

import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import FeatureTripListing from "./featureTrip";
import DownloadIcon from "@mui/icons-material/Download";
import ExploreTripListing from "./exploreTrip";
import Switch from "@mui/material/Switch";
import moment from "moment";
import { Helmet } from "react-helmet";
import { useAuth } from "../auth/authContext";
const TripListing = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [value, setValue] = useState("1");
  const [write, setWrite] = useState(false);

  const [downloadData, setDownloadData] = useState([]);

  const headers = [
    { label: "Trip Name", key: "tripName" },
    { label: "User Name", key: "userName" },
    { label: "Created Date", key: "createdAt" },
    { label: "Feature Status", key: "featureuserStatus" },
    { label: "Explore Status", key: "exploreuserStatus" },
  ];

  useEffect(() => {
    if (passedValue) {
      fetchAllTrip(0, "", passedValue);
    } else {
      fetchAllTrip(0, "", "");
    }
    handleDownloadProcess();
  }, [passedValue]);
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-trip", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-trip-csv-data")
      .then((resp) => {
        setDownloadData(resp?.data?.data);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"trip.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "Action",
      label: "Trip Image",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <img
                src={allTrip[dataIndex]?.locationImg}
                style={{ width: "60px" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "tripName",
      label: "Trip Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "mail",
      label: "User Name",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <div>{allTrip[dataIndex]?.userId?.name}</div>;
        },
      },
    },
    {
      name: "role",
      label: "Created Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allTrip[dataIndex].createdAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },

    write && {
      name: "feature trip",
      label: "Feature Trip",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {write ? (
                <>
                  <Switch
                    checked={allTrip[dataIndex]?.featureTrip}
                    onChange={(event) =>
                      handleChangeExplore(
                        event,
                        allTrip[dataIndex]?._id,
                        "feature"
                      )
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
    write && {
      name: "Explore Trip",
      label: "Explore Trip",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {write ? (
                <>
                  <Switch
                    checked={allTrip[dataIndex]?.explore}
                    onChange={(event) =>
                      handleChangeExplore(
                        event,
                        allTrip[dataIndex]?._id,
                        "explore"
                      )
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ].filter(Boolean);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "1") {
      if (passedValue) {
        fetchAllTrip(0, "", passedValue);
        setPage(0);
      } else {
        fetchAllTrip(0, "", "");
        setPage(0);
      }
    }
  };

  const handleChangeExplore = (event, tripId, type) => {
    handleStatus(tripId, type);
  };
  const handleStatus = (id, type) => {
    let api;
    let data = {
      id: id,
      userID: passedValue ? passedValue : "",
      page: page,
    };
    if (type === "explore") {
      api = "update-explore-trips";
    } else {
      api = "update-feature-trip";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-Trip</title>
        <meta name="Trip List" content="Trip List for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>Trip Management</h2>
      </div>

      <Tabs
        value={value}
        onChange={handleChange}
        className="mb-4"
        sx={{
          "& button": {
            borderRadius: 2,
            color: "#000",
            transition: "all 0.3s",
          },
          "& button:hover": {
            color: "#3dd2cc",
          },
          "& button.Mui-selected": {
            color: "#3dd2cc",
            fontWeight: "bold",
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "black",
          },
        }}
      >
        <Tab className="fs-14 fw-600 p-2 mr-2" value="1" label="Trip List" />
        <Tab
          className="fs-14 fw-600 p-2 mr-2"
          value="2"
          label="Feature Trip List"
        />
        <Tab className="fs-14 fw-600 p-2" value="3" label="Explore Trip List" />
      </Tabs>
      {value === "1" ? (
        <MUIDataTable
          title={"Trip List"}
          data={allTrip}
          columns={columns}
          options={options}
        />
      ) : value === "2" ? (
        <>
          <FeatureTripListing />
        </>
      ) : (
        <ExploreTripListing />
      )}
    </>
  );
};
export default TripListing;
